import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { ITaskCreator } from './ITaskCreator';
import { CreateTaskModel } from "./CreateTaskModel";

class TaskCreator implements ITaskCreator {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    createTask(model: CreateTaskModel): Promise<boolean> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/tasks/create',
            method: HttpMethod.PUT
        }, model);

        return new Promise((resolve, reject) => {
            this.manager
                .send(request)
                .then((res) => {
                    if (res.ok) {
                        resolve(true);
                    } else {
                        console.log(res);
                        throw 'Error creating task.';
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve(false);
                });
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<ITaskCreator>('ITaskCreator', (frm) => {
        return new TaskCreator(frm);
    });
}